<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3 class="mx-auto">
            Agreement Accepted (Total: {{totalOrders}})
          </h3>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              color="accent"
              label="Search Orders"
              single-line
              style="max-width: 300px"
            ></v-text-field>
            <v-btn
            color="accent"
            :loading="downloadingCustomer"
            :disabled="downloadingCustomer"
            class="ma-1"
            @click="downloadRecords('policy-agreements')"
          >
            Download
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :search="search"
            :loading="loading"
            item-key="uid"
            :items="orders"
            :headers="headers"
          >
            <template v-slot:item.created_at="{ item }">
              {{item.created_at | orderDateTime}}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      orders: [],
      loading: false,
      search: '',
      asoFilter: null,
      sureToDeleteDialog: false,
      asoToDelete: true,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
    };
  },
  filters: {
    orderDateTime: (value) => {
      const d = new Date(value.seconds * 1000);
      return `${String(d.getDate()).padStart(2, 0)}/${String(d.getMonth() + 1).padStart(2, 0)}/${d.getFullYear()} ${String(d.getHours()).padStart(2, 0)}:${String(d.getMinutes()).padStart(2, 0)}:${String(d.getSeconds()).padStart(2, 0)}`;
    },
  },
  methods: {
    async getOrders() {
      // Fetch ASOs here
      this.loading = true;
      try {
        const { orders } = this;
        const orderQuery = await this.firebase.firestore().collection('policy-agreements').get();
        // const orderQuery = [];
        orderQuery.forEach(async (item) => {
          orders.push({ uid: item.id, ...await item.data() });
        });
        // this.asos = asos;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async downloadRecords(table) {
      // here we will download the csv file dealers
      try {
        this.downloadingCustomer = true;
        let csvData = 'code, ip, name, counterName, accepted, email, description, type, phone\r\n';

        for (let i = 0; i < this.orders.length; i += 1) {
          /* eslint-disable */
          const dealer = this.orders[i];
          csvData += `${dealer.code.trim()},${dealer.ip.trim()} ,${(dealer.name? dealer.name.trim(): '')}, ${(dealer.counterName? dealer.counterName.trim(): '')}, ${(dealer.accepted)}, ${(dealer.email? dealer.email.trim(): '')}, ${(dealer.description? dealer.description.trim(): '')}, ${(dealer.type? dealer.type.trim(): '' )}, ${dealer.phone}\r\n`;
        }
        /* eslint-enable */
        this.downloadingCustomer = false;
        const aTag = document.createElement('a');
        aTag.href = window.URL.createObjectURL(new Blob([csvData], { type: 'text/csv;charset=utf-8;' }));
        aTag.setAttribute('download', `${table}.csv`);
        aTag.click();
      } catch (error) {
        this.downloadingCustomer = false;
        console.log(error);
      }
    },
  },
  computed: {
    accentColor() {
      return this.$vuetify.theme.themes.light.accent;
    },
    totalOrders() {
      return this.orders.length;
    },
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Counter Name',
          value: 'counterName',
        },
        {
          text: 'Counter Type',
          value: 'type',
        },
        {
          text: 'Type Descprition',
          value: 'description',
        },
        {
          text: 'IP',
          value: 'ip',
        },
        {
          text: 'Created At',
          value: 'created_at',
        },
      ];
    },
  },
  beforeMount() {
    this.getOrders();
  },
};
</script>
